module.exports = __webpack_public_path__ + "img/OmbParkO.8eef4ba5.png";